import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
let TaskNote = class TaskNote extends Vue {
    value;
    disabled;
    get taskNote() {
        return this.$props.value;
    }
    set taskNote(val) {
        this.$emit('input', val);
    }
};
__decorate([
    Prop()
], TaskNote.prototype, "value", void 0);
__decorate([
    Prop({ default: false, type: Boolean })
], TaskNote.prototype, "disabled", void 0);
TaskNote = __decorate([
    Component({
        name: 'TaskNote',
        components: {},
        i18n: {
            messages: {
                zh: {
                    title: '备注',
                    placeholderTip: '在此处添加任务注释',
                },
                en: {
                    title: 'Task Note',
                    placeholderTip: 'Add task note here',
                },
            },
        },
    })
], TaskNote);
export default TaskNote;
